<template>
  <header class="d-flex align-items-center w-100">
    <section
      class="w-55"
      :class="{
        'd-flex align-items-center gap-2': backArrow,
        'd-flex align-items-center justify-content-between w-100': isButton || universityData.isUniversity,
      }"
    >
      <img
        class="pointer"
        @click="goBackFunc"
        v-if="backArrow"
        src="@/assets/studentDetails/backarw.svg"
        alt=""
      />
      <h2
        :class="{ 'w-75': isButton }"
        class="fs-20 fw-600 lh-130 font-lato color-mainblue w-90 text-truncate"
      >
        {{ title }}
      </h2>
      <b-button
        type="button"
        class="clg-add-btn px-4 width-unset"
        v-if="isButton"
        @click="$emit('show-modal')"
      >
        <img src="../../assets/inputImgs/whiteplus.svg" class="mr-2" alt="" />
        College
      </b-button>
      <div v-if="universityData.isUniversity && $route.name== 'CandidateDetails'" class="cdash-tabs" style="right:30px !important">
       <div  @click="$emit('switch-tab', 'basic')" :class="activeTab === 'basic' ? 'select pointer' : 'unselect pointer'">Basic</div>
       <!-- <div @click="$emit('switch-tab', 'all')" :class="activeTab === 'all' ? 'select pointer' : 'unselect pointer'">
          All
        </div> -->
    </div>
    </section>
  </header>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "SubHeader",
  props: {
    title: {
      type: String,
      default: "",
    },
    backArrow: {
      type: Boolean,
      default: false,
    },
    goBackFunc: {
      type: Function,
      default: () => {},
    },
    isButton: {
      type: Boolean,
      default: false,
    },
    activeTab: {
      type: String,
      default: "all",
    },
  },
  computed: {
    ...mapGetters("userVUEX", {
      universityData: "getUniversityData",
    }),
  },
};
</script>

<style scoped>
header {
  padding: 5px 20px;
  gap: 15px;
  height: 52px;
  background: #f6f9fb;
  border-radius: 8px;
}
.w-625px {
  width: 625px;
}
</style>
